import { render, staticRenderFns } from "./nft.vue?vue&type=template&id=0e44c0b5&scoped=true&"
import script from "./nft.vue?vue&type=script&lang=js&"
export * from "./nft.vue?vue&type=script&lang=js&"
import style0 from "./nft.vue?vue&type=style&index=0&id=0e44c0b5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e44c0b5",
  null
  
)

export default component.exports